module.exports = __webpack_public_path__ + "media/images/niq-add-c315d194be6e52ad7bdd9914a928136c.svg";